export const MONTH_DAY_YEAR_FORMAT = 'MM/DD/YYYY';
